export const mapAuthStateToDefaultPath: Record<string, string> = {
  FULL: "/home",
  ONBOARDING_REQUIRED: "/enrollment",
  PASSWORD_REQUIRED: "/auth/set-password",
  PHONE_VERIFICATION_REQUIRED: "/auth/verify",
  UNAUTHED: "/auth",
};
